import { useState } from "react";
import DriverAlertDataTiles from "./components/DriverDataTiles";
import DriverAlertDataTable from "./components/DriverAlertDataTable";
import { useLocation } from "react-router-dom";


type ColumnObjType = {
  [key: string]: {
    name: string;
    status: boolean;
  };
};

export default function DriverAlerts() {
  const location = useLocation();

  const [tileData, setTilesData] = useState<ColumnObjType>()
  const handleTiles = (data: ColumnObjType) => {
    setTilesData(data)
  }
  return (
    <div className="flex flex-col gap-4 mt-4">
      <div className="flex-1">
        <DriverAlertDataTiles data={tileData} />
      </div>
      <div className="flex-1 tripTable">
        <DriverAlertDataTable handleTile={handleTiles}/>
      </div>
    </div>

  );
}
